import React, { Suspense } from 'react';
import { useAuth } from './context/AuthContext';
import BuyerApp from './BuyerApp';
const AdminApp = React.lazy(() => import('./adminsrc/App'));

function App() {
  const { user, loading } = useAuth();

  if (loading) return <div>Loading...</div>;

  // Always show BuyerApp (which includes login page) if not logged in
  if (!user) return <BuyerApp />;

  // If logged in and admin/seller, switch to AdminApp
  if (user.roles && (user.roles.includes('ROLE_ADMIN'))) {
    return (
      <Suspense fallback={<div>Loading admin...</div>}>
        <AdminApp />
      </Suspense>
    );
  }
  // If logged in and admin/seller, switch to AdminApp
  if (user.roles.includes('ROLE_SELLER')) {
    return (
      <Suspense fallback={<div>Loading Seller...</div>}>
        <AdminApp />
      </Suspense>
    );
  }

  // Otherwise, continue with BuyerApp
  return <BuyerApp />;
}

export default App;
